// React Dependiencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

// Internal Dependencies
import Colours from '../styles/colours';
import MText from './Common/MText';
import { IsEmpty } from '../common/checks';

const MButton = (props) => {
  const onBtnClick = (e) => {
    if (props.type === 'button') {
      props.onClick(e);
    }
  };
  return (
    <Button
      variant={props.variant}
      className={props.className}
      onClick={onBtnClick}
      style={{ backgroundColor: props.colour, ...props.style }}
      disabled={props.disabled}
      type={props.type}
      disableElevation
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
      startIcon={props.startIcon ? (typeof props.startIcon === 'function' ? props.startIcon() : props.startIcon) : undefined}
      endIcon={props.endIcon ? (typeof props.endIcon === 'function' ? props.endIcon() : props.endIcon) : undefined}
    >
      {!IsEmpty(props.icon) && props.icon()}
      <MText
        medium={props.textMedium}
        semibold={props.textSemibold}
        bold={props.textBold}
        size={props.textSize}
        className={props.textClassName}
        colour={props.textColour}
        style={props.textStyle}
        text={props.text}
      />
    </Button>
  );
};

MButton.propTypes = {
  className: PropTypes.string,
  colour:    PropTypes.string,
  onClick:   PropTypes.func.isRequired,
  icon:      PropTypes.func,

  text:         PropTypes.string,
  textMedium:   PropTypes.bool,
  textSemibold: PropTypes.bool,
  textBold:     PropTypes.bool,

  disabled:         PropTypes.bool,
  disableElevation: PropTypes.bool,
  textClassName:    PropTypes.string,
  textSize:         PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  textColour:       PropTypes.string,
  style:            PropTypes.shape({}),
  type:             PropTypes.oneOf(['button', 'submit', 'reset']),
  variant:          PropTypes.oneOf(['text', 'outlined', 'contained']),
  textStyle:        PropTypes.shape({}),
  onMouseOver:      PropTypes.func,
  onMouseOut:       PropTypes.func,
  startIcon:        PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  endIcon:          PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};

MButton.defaultProps = {
  startIcon: null,
  endIcon:   null,

  text:         '',
  textMedium:   false,
  textSemibold: false,
  textBold:     false,

  colour:           Colours.White,
  textSize:         13,
  disabled:         false,
  disableElevation: false,
  className:        '',
  textColour:       '',
  textClassName:    '',
  style:            {},
  type:             'button',
  icon:             null,
  textStyle:        {},
  variant:          'contained',
  onMouseOver:      null,
  onMouseOut:       null,
};

export default MButton;
